import React, {useState, useEffect} from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,
  CPagination,
  CButton,
  CPopover, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CForm, CFormGroup, CLabel, CInput, CCardFooter,
} from "@coreui/react";

import Modules from "../../../models/Modules";
import SubModuleTrainingModal from "../Modals/SubModuleTrainingModal";
import Role from "../../../utils/Role";
import CIcon from "@coreui/icons-react";
import UserTraining from "../../../models/UserTraining";
import _ from "lodash"

const ModuleDetailPage = () => {
  const history = useHistory();

  const {id: moduleId} = useParams();

  const queryPage = useLocation().search.match(/page=([0-9]+)/, "");
  const currentPage = Number(queryPage && queryPage[1] ? queryPage[1] : 1);
  const [page, setPage] = useState(currentPage);

  const [subModules, setSubModules] = useState([]);
  const [module, setModule] = useState({})

  const [selectedSubModule, setSelectedSubModule] = useState(0);
  const [selectedSubModuleName, setSelectedSubModuleName] = useState(null);

  const [isTrainingModalShown, setIsTrainingModalShown] = useState(false)

  const [audioLabels, setAudioLabels] = useState([])
  const [scoreLabels, setScoreLabels] = useState([])
  const [userTraining, setUserTraining] = useState(null);
  const [isMentorReviewShown, setMentorReviewShown] = useState(false);
  const [selectedSubmission, setSelectedSubmission] = useState({});
  const [selectedIdx, setSelectedIdx] = useState(-1);

  const [mentorComment, setMentorComment] = useState(null)
  const [mentorScore, setMentorScore] = useState(null)
  const [selectedUserTrainingId, setSelectedUserTrainingId] = useState(null);

  const [mentorAsLearnerData, setMentorAsLearnerData] = useState([])

  const [learnerMode, setLearnerMode] = useState(true)

  let role = "LEARNER";
  if (localStorage.getItem('role')) role = localStorage.getItem('role');
  else if (sessionStorage.getItem('role')) role = sessionStorage.getItem('role');

  const mentorFields = [
    {key: "viewing_id", _classes: "font-weight-bold", label: "ID"},
    {key: "name", _classes: "font-weight-bold", label: "Nama"},
    {key: "status", label: "Status"},
    {key: "description", label: "Deskripsi"},
    {
      key: "actions",
      label: "",
      _style: {width: '20%'},
      sorter: false,
      filter: false,
    },
  ]

  const learnerFields = [
    {key: "viewing_id", _classes: "font-weight-bold", label: "ID"},
    {key: "name", _classes: "font-weight-bold", label: "Nama"},
    {key: "mentor_names", label: "Mentor"},
    {key: "status", label: "Status"},
    {key: "description", label: "Deskripsi"},
    {
      key: "actions",
      label: "",
      _style: {width: '20%'},
      sorter: false,
      filter: false,
    },
  ]

  console.log("learner mode", learnerMode)

  const pageChange = (newPage) => {
    currentPage !== newPage && history.push(`/branches/${moduleId}?page=${newPage}`);
  };

  useEffect(() => {
    currentPage !== page && setPage(currentPage);
    getData();

    getMentorDataAsLearner()

  }, [currentPage, page]);

  const getData = async () => {
    let moduleModel = new Modules();

    let userTrainingData = await moduleModel.getModuleDetail(moduleId);


    let groupedTraining = _.groupBy(userTrainingData.subModules, (obj,key)=>{
      return obj.id
    })

    console.log(userTrainingData, groupedTraining)


    const essentialOnly = []

    for (let submoduleId in groupedTraining) {

      let temp = groupedTraining[submoduleId][0]

      temp.mentor_names = ""

      let idx = 0;

      let userTrainings = []
      let ids = []

      for(let obj of groupedTraining[submoduleId]){

        temp.mentor_names += obj.mentor_name
        if(idx < groupedTraining[submoduleId].length - 1){
          temp.mentor_names += ", "
        }
        idx++;
        userTrainings.push({...obj})
        ids.push(obj.id)

      }

      temp.user_trainings = userTrainings
      temp.ids = ids

      essentialOnly.push(temp)

    }
    setSubModules(essentialOnly)
    setModule(userTrainingData);
  };

  const getMentorDataAsLearner = async () => {

    if(role === 'MENTOR' ){
      let userModel = new UserTraining();
      let mentorLearnerData = await userModel.getUserTrainingAsMentor(moduleId);

      let groupedTraining = _.groupBy(mentorLearnerData, (obj,key)=>{
        return obj.submodule_id
      })

      const essentialOnly = []

      for (let submoduleId in groupedTraining) {

        let temp = groupedTraining[submoduleId][0]

        temp.mentor_names = ""

        let idx = 0;

        let userTrainings = []
        let ids = []

        for(let obj of groupedTraining[submoduleId]){

          temp.mentor_names += obj.mentor_name
          if(idx < groupedTraining[submoduleId].length - 1){
            temp.mentor_names += ", "
          }
          idx++;
          userTrainings.push({...obj})
          ids.push(obj.id)

        }

        temp.user_trainings = userTrainings
        temp.ids = ids

        essentialOnly.push(temp)

      }

      console.log(mentorLearnerData)
      setMentorAsLearnerData(essentialOnly)
    }

  }

  console.log("LMLMLM " + learnerMode)

  return (
    <>
      <CRow>
        <CCol xl={12}>
          <CCard>
            <CCardHeader>
              Pelatihan <br/>
              <b style={{fontSize: "1.2em"}}>{module.name}</b><br/>
              <a href={"/"}><small>Kembali ke daftar pelatihan</small></a>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md={"6"}>

                  <b>Nama</b> : {module.name}<br/>
                  <b>Deskripsi</b> : {module.description}

                  <br/>
                  <br/>
                  <br/>
                </CCol>
              </CRow>
              <CRow style={{marginBottom: "1em"}}>
                <CCol style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}>
                  <b style={{fontSize: "1.1em"}}>Daftar Submodul</b>
                  <small>{role === 'MENTOR' && 'Sebagai Mentor'}</small>
                </CCol>

                {/*{role !== Role.UPPER_MANAGEMENT &&*/}
                {/*<CCol*/}
                {/*  xs="6"*/}
                {/*  style={{*/}
                {/*    display: "flex",*/}
                {/*    justifyContent: "flex-end",*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <CButton*/}
                {/*    onClick={() => {*/}
                {/*      history.push(`/branches/editForm/` + moduleId)*/}
                {/*    }}*/}
                {/*    style={{*/}
                {/*      marginRight: 10*/}
                {/*    }}*/}
                {/*    variant={"outline"}*/}
                {/*    color="success">*/}
                {/*    Edit pelatihan*/}
                {/*  </CButton>*/}
                {/*  <CButton*/}
                {/*    onClick={() => {*/}
                {/*      history.push(`/modules/${moduleId}/create`);*/}
                {/*    }}*/}
                {/*    size="md"*/}
                {/*    variant="outline"*/}
                {/*    color="info"*/}
                {/*  >*/}
                {/*    + Submodul Baru*/}
                {/*  </CButton>*/}
                {/*</CCol>*/}
                {/*}*/}
              </CRow>
              <CDataTable
                tableFilter={{placeholder: "Search Here"}}
                items={subModules}
                fields={role === "MENTOR" ? mentorFields : learnerFields}
                hover
                striped
                itemsPerPage={10}
                activePage={page}
                // clickableRows
                scopedSlots={{
                  actions: (item) => (
                    <td>
                      {
                        role === "LEARNER" ?
                          <CButton
                            color={"primary"}
                            disabled={!item?.user_training?.submitted_at}
                            onClick={() => {
                              setSelectedSubModuleName(item.name)
                              setUserTraining(item)
                              setIsTrainingModalShown(true)
                            }}
                          >
                            {item?.user_training?.submitted_at ? "Lihat Hasil" : "Belum Dikerjakan"}
                          </CButton>
                          :
                          <CButton
                            color={"primary"}
                            onClick={() => {
                              setSelectedSubModuleName(item.name)
                              setAudioLabels(item.label_audio)
                              setScoreLabels(item.label_scores)
                              setSelectedSubModule(item.id)
                              setIsTrainingModalShown(true)
                              setLearnerMode(false)
                              console.log("LEARNER MODE IS TOGGLE TO FALSE")
                            }}
                          >
                            Lihat Pengumpulan
                          </CButton>
                      }


                      {/*{role !== Role.UPPER_MANAGEMENT &&*/}
                      {/*<CButton*/}
                      {/*  onClick={() => {*/}
                      {/*    history.push(`/submodules/edit/${item.id}`)*/}
                      {/*  }}*/}
                      {/*  style={{*/}
                      {/*    marginLeft: 10*/}
                      {/*  }}*/}
                      {/*  variant={"outline"}*/}
                      {/*  style={{marginLeft: " 1em"}}*/}
                      {/*  color="success">*/}
                      {/*  Edit*/}
                      {/*</CButton>*/}
                      {/*}*/}
                    </td>
                  ),
                }}
              />
              <CPagination
                activePage={page}
                onActivePageChange={pageChange}
                pages={subModules.length ? Math.ceil(subModules.length / 10) : 1}
                doubleArrows={false}
                align="center"
              />

              {
                mentorAsLearnerData.length > 0 && <>
                  <CRow style={{marginBottom: "1em"}}>
                    <CCol style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center"
                    }}>
                      <b style={{fontSize: "1.1em"}}>Daftar Submodul</b>
                      <small>Sebagai Learner</small>
                    </CCol>

                  </CRow>
                  <CDataTable
                    tableFilter={{placeholder: "Search Here"}}
                    items={mentorAsLearnerData}
                    fields={learnerFields}
                    hover
                    striped
                    itemsPerPage={10}
                    activePage={page}
                    // clickableRows
                    scopedSlots={{
                      actions: (item) => (
                        <td>

                          <CButton
                            color={"primary"}
                            disabled={!item?.user_training?.submitted_at}
                            onClick={() => {
                              setSelectedSubModuleName(item.name)
                              setUserTraining(item)
                              setIsTrainingModalShown(true)
                            }}
                          >
                            {item?.user_training?.submitted_at ? "Lihat Hasil" : "Belum Dikerjakan"}
                          </CButton>


                        </td>
                      ),
                    }}
                  />
                  <CPagination
                    activePage={page}
                    onActivePageChange={pageChange}
                    pages={subModules.length ? Math.ceil(subModules.length / 10) : 1}
                    doubleArrows={false}
                    align="center"
                  />
                </>
              }


            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <SubModuleTrainingModal
        learnerMode={learnerMode}
        userTraining={userTraining}
        audioLabels={audioLabels}
        scoreLabels={scoreLabels}
        subModule={selectedSubModule}
        show={isTrainingModalShown}
        showMentorReview={(item, submission, idx, userTrainingId) => {
          console.log('selectedSubmission', item)

          if (item.mentor_score) {
            setMentorScore(item.mentor_score[idx])
          }
          if (item.mentor_comment) {
            setMentorComment(item.mentor_comment[idx])
          }
          setSelectedUserTrainingId(userTrainingId)
          setSelectedIdx(idx);
          item.submission = submission;
          setSelectedSubmission(item)
          setIsTrainingModalShown(false)
          setMentorReviewShown(true)
        }}
        onClose={(() => {
          setIsTrainingModalShown(false)
          setSelectedSubModule(0)
          setLearnerMode(true)
          setUserTraining(false)
          console.log("LEARNER MODE IS TOGGLE TO TRUE")
        })}
      />

      <CModal size={'md'} show={isMentorReviewShown} onClose={() => {
        setMentorComment(null)
        setMentorScore(null)
        // setIsTrainingModalShown(true);
        setMentorReviewShown(false)
        setLearnerMode(true)
        console.log("LEARNER MODE IS TOGGLED TO TRUE")

      }} centered>
        <CModalHeader closeButton>
          <CModalTitle>
            Mentor Review - {selectedSubmission.submission}
            <br/>
          </CModalTitle>
        </CModalHeader>

        <CModalBody>

          {
            learnerMode && <>
              <table style={{width: "100%"}}>
                <tr>
                  <td style={{width: "20%"}}><b>Submodule</b></td>
                  <td> : {selectedSubModuleName}</td>
                </tr>
                {!learnerMode ?
                  <tr>
                    <td><b>Pengumpul</b></td>
                    <td> : {selectedSubmission.user?.full_name}</td>
                  </tr> : null
                }
              </table>

              <hr/>
            </>
          }



          {
            selectedSubmission?.user_trainings?.map((obj,key)=>{
              return <>
                {
                  (role === 'LEARNER' || learnerMode) && <table style={{width: "100%"}}>
                    {(role === 'LEARNER' || learnerMode) &&
                    <tr>
                      <td style={{width: "20%"}}><b>Mentor</b></td>
                      <td> : {obj.mentor_name}</td>
                    </tr>
                    }
                    <tr>
                      <td style={{width: "20%"}}><b>Nilai</b></td>
                      <td> : {Array.isArray(obj.user_training?.mentor_score) ? obj.user_training.mentor_score[selectedIdx] : '-'}</td>
                    </tr>
                    <tr>
                      <td style={{width: "20%", verticalAlign: "top"}}><b>Komentar</b></td>
                      <td> : {Array.isArray(obj.user_training?.mentor_comment) ? obj.user_training.mentor_comment[selectedIdx] : '-'}</td>
                    </tr>
                  </table>
                }

                {
                  key < selectedSubmission.user_trainings.length - 1 && <hr/>
                }

              </>
            })
          }


          {!learnerMode &&
          <CForm
            action=""
            method="post"
            encType="multipart/form-data"
            className="form-horizontal"
          >
            <CFormGroup>

              <CLabel htmlFor="text-input">Nilai</CLabel>

              <CInput
                id="text-input"
                name="text-input"
                placeholder="Masukan Nilai"
                value={mentorScore ? mentorScore : ''}
                onChange={(e) => setMentorScore(e.target.value)}
              />
              {/* <CFormText>This is a help text</CFormText> */}
            </CFormGroup>


            <CFormGroup>

              <CLabel htmlFor="text-input">Komentar</CLabel>

              <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                        placeholder={'Masukan Komentar'}
                        value={mentorComment ? mentorComment : ""}
                        onChange={(e) => setMentorComment(e.target.value)}
              ></textarea>
              {/* <CFormText>This is a help text</CFormText> */}
            </CFormGroup>
          </CForm>
          }
        </CModalBody>

        {!learnerMode &&
        <CCardFooter>
          <CButton
            onClick={async () => {
              let userTrainingModel = new UserTraining();

              let mentorScores = selectedSubmission.mentor_score ? selectedSubmission.mentor_score : new Array(audioLabels.length).fill(null);
              let mentorComments = selectedSubmission.mentor_comment ? selectedSubmission.mentor_comment : new Array(audioLabels.length).fill(null);

              let floatScore = parseFloat(mentorScore)

              if (!mentorScore) {
                alert('Nilai tidak boleh tidak diisi!')
              } else if (!floatScore || isNaN(mentorScore)) {
                alert('Masukan nilai yang valid')
              } else {

                if (floatScore < 0 || floatScore > 100) {
                  return alert('Masukan nilai diantara 0 dan 100')
                }

                mentorScores[selectedIdx] = floatScore.toFixed(2);

                if (mentorComment) mentorComments[selectedIdx] = mentorComment

                try {
                  let result = await userTrainingModel.commentTrainingAsMentor(selectedUserTrainingId, mentorComments, mentorScores);

                  if (result.affectedRows === 1) {
                    setMentorComment(null);
                    setMentorScore(null);
                    getData()
                    alert("Review Anda berhasil tersimpan!")

                    setMentorReviewShown(false)
                  }
                  console.log('result', result)
                } catch (e) {
                  console.log('err', e)
                }
              }
            }}
            type="submit"
            size="sm"
            color="primary"
          >
            <CIcon name="cil-scrubber"/> Simpan
          </CButton>
        </CCardFooter>
        }
      </CModal>
    </>
  );
};

export default ModuleDetailPage;
